import cryptoJS from 'crypto-js';
import { ERROR_TYPES } from '../constants';
import { doTagCancel } from '../tagging';
import { useSubmit } from './useSubmit';
import { useAddress } from './useAddress';
import { useFieldsValidation } from './useFieldsValidation';

const { CLIENT_ACCOUNT_NOT_IN_HOLDING, CLIENT_IS_BLOCKED, POSTALCODE_NOT_MATCH_PROVINCE, POSTALCODE_NOT_VALID } =
    ERROR_TYPES;

export const useHandlers = ({
    actions,
    consentsActions,
    createActions,
    focusActions,
    formActions,
    formValidations,
    goToErrorsView,
    ibanActions,
    immStepsState,
    options,
    preLoaderActions,
    scorings,
    showModalCancel,
    userProfile,
    userProfileForm,
}) => {
    const { accessToken, docNumber } = userProfile;

    const { disableFollowingStep, enableFinishedAndNextStep, savePersonalInformation } = actions;

    const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
    const currentIndex = immStepsState.get('currentStep');
    const steps = immStepsState.get('steps');

    const redirectErrors = error => {
        const errorType = error.body.errors;
        if (errorType[POSTALCODE_NOT_MATCH_PROVINCE] || errorType[POSTALCODE_NOT_VALID]) {
            formActions.setValidity('userProfile.postalCode', { zip: false });
        }
        const errorTypeClientAccountNotInHolding = errorType[CLIENT_ACCOUNT_NOT_IN_HOLDING];
        const errorTypeClientIsBlocked = errorType[CLIENT_IS_BLOCKED];
        if (errorTypeClientAccountNotInHolding || errorTypeClientIsBlocked) {
            goToErrorsView({
                errorCode: errorTypeClientAccountNotInHolding ? CLIENT_ACCOUNT_NOT_IN_HOLDING : CLIENT_IS_BLOCKED,
            });
        }
    };

    const { isClicked, handleSubmit, handleEnableSubmit } = useSubmit({
        actions,
        consentsActions,
        createActions,
        currentIndex,
        docNumberEncrypted,
        formActions,
        formValidations,
        goToErrorsView,
        ibanActions,
        immStepsState,
        options,
        preLoaderActions,
        redirectErrors,
        scorings,
        steps,
        userProfile,
        userProfileForm,
    });

    const handleSave = (name, value) => {
        const data = name ? { [name]: value } : value;
        const showLoader = false;

        if (name === 'homeAddress' && typeof value.addressNumber !== 'undefined' && value.addressNumber === '') {
            data[name].addressNumber = null;
        }
        savePersonalInformation(data, accessToken, showLoader, (saved, errors) => {
            if (!saved) {
                redirectErrors(errors);
            }
        });
    };

    const handleNextStep = valid => {
        const currentStep = steps.get(currentIndex);

        if (currentStep.get('finished')) {
            if (valid && userProfileForm.$form.valid) {
                enableFinishedAndNextStep();
            } else {
                disableFollowingStep({
                    index: currentIndex,
                });
            }
        }
    };

    const { handleAddressUpdate } = useAddress({
        formActions,
        handleNextStep,
        handleSave,
        userProfile,
        userProfileForm,
    });

    const handleCancel = () => {
        doTagCancel();
        showModalCancel();
    };

    const { onHandleValidateFields } = useFieldsValidation({
        docNumberEncrypted,
        focusActions,
        formActions,
        formValidations,
        immStepsState,
        scorings,
        userProfile,
    });

    return {
        handleAddressUpdate,
        handleCancel,
        handleEnableSubmit,
        handleNextStep,
        handleSave,
        handleSubmit,
        isClicked,
        onHandleValidateFields,
    };
};
